/**
 * Unberührte Vorbelegung ist kein Entwurf (Kundenfeedback 16.09.26).
 *
 * Wird „Neue E-Mail" aus einer Akte geöffnet, belegt der Dialog Betreff
 * („[2416/26] Reichenbächer-Britta-12.09.2026"), Signatur und ggf. Empfänger
 * vor. Das Auto-Speichern hat daraus nach 1,2 s einen Entwurf gemacht — auch
 * wenn der Anwender das Fenster ohne jede Eingabe wieder schloss. Im Ordner
 * „Entwürfe" stand dann eine E-Mail, die nie jemand geschrieben hat.
 *
 * Der Fingerabdruck beschreibt den inhaltlichen Stand des Dialogs. Direkt nach
 * der Vorbelegung wird er als Ausgangsstand gemerkt; solange er unverändert
 * ist, wird kein Entwurf gespeichert.
 */

export interface ComposeState {
  subject: string
  html: string
  recipients: { userId: number | string, role?: string }[]
  externals: { email: string, role?: string }[]
  attachmentCount: number
}

/** Sichtbarer Text eines Editor-Inhalts (ohne Markup, normalisiert). */
export function composeText (html: string | null | undefined): string {
  return String(html || '')
    .replace(/<style[\s\S]*?<\/style>/gi, ' ')
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}

export function composeFingerprint (state: ComposeState): string {
  return JSON.stringify({
    subject: String(state.subject || '').trim(),
    text: composeText(state.html),
    recipients: (state.recipients || []).map(r => `${r.role || 'to'}:${r.userId}`),
    externals: (state.externals || []).map(e => `${e.role || 'to'}:${String(e.email || '').trim().toLowerCase()}`),
    attachments: Number(state.attachmentCount) || 0,
  })
}

/** true, wenn der Dialog seit der Vorbelegung inhaltlich unverändert ist. */
export function isPristineCompose (state: ComposeState, baseline: string | null): boolean {
  return baseline !== null && composeFingerprint(state) === baseline
}
